// extracted by mini-css-extract-plugin
export default {"content":"style_content__tNque","title":"style_title__WopZJ","noAccess":"style_noAccess__FzZgf"};